function Tags({ product }) {
	return (
		<div className="tags">
			{product.tags && product.tags.map((tag, i) => <div key={i}>{tag.name}</div>)}
		</div>
	);
}

export default Tags;
